import { useCallback } from 'react';

import * as Sentry from '@sentry/react';
import { Apollo } from 'src/gql/generated';
import { useGetCurrentDoc } from 'src/hooks';

export function useSpellcheckEnabled(): {
  enabled: boolean;
  loading: boolean;
  setEnabled: (enabled: boolean) => void;
} {
  const { document, loading } = useGetCurrentDoc();
  const [setDocumentSpellcheckEnabled] = Apollo.useSetDocumentSpellcheckEnabledMutation();

  const documentId = document?.id ?? null;
  const enabled = document?.requesterSpellcheckEnabled ?? true;

  const setEnabled = useCallback(
    (next: boolean) => {
      if (!documentId) return;
      void setDocumentSpellcheckEnabled({
        optimisticResponse: {
          __typename: 'Mutation',
          setDocumentSpellcheckEnabled: {
            __typename: 'Document',
            id: documentId,
            requesterSpellcheckEnabled: next,
          },
        },
        variables: { input: { documentId, enabled: next } },
      }).catch((error: unknown) => {
        Sentry.captureException(error, { tags: { feature: 'spellcheck' } });
      });
    },
    [documentId, setDocumentSpellcheckEnabled]
  );

  return { enabled, loading: loading && !document, setEnabled };
}
